<template>
	<div class="gonggao">
		<el-card :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto'}">
			<el-row>
				<el-col :span="5" style="color:transparent;">1</el-col>
				<el-col :span="12">
					<el-form ref="form" :model="item" label-width="80px" v-for="(item,index) in form.msglist" :key="index">
						<el-form-item :label="gonggaolang.sellang">
							<el-select size="mini" v-model="item.lang" placeholder="" style="width:200px">
								<el-option :label="ite.label" :value="ite.value" v-for="(ite, idx) in langlist" :key="idx"></el-option>
							</el-select>
					   </el-form-item>
					   <el-form-item :label="gonggaolang.noticetitle">
						  <el-input type="textarea" v-model="item.notice" rows="5">
						  </el-input>
					   </el-form-item>
					   <el-form-item >
							<el-link v-if="form.msglist.length>1" type="danger" @click="delset(index)">{{gonggaolang.delset}}</el-link>
					   </el-form-item>
					</el-form> 
				</el-col>
			</el-row>
			<el-row v-if="form.msglist.length<langlist.length">
				<el-col :span="5" style="color:transparent;">1</el-col>
				<el-col :span="12">
					<el-button @click="addset" type="warning" size="mini">{{gonggaolang.addset}}</el-button>
				</el-col>
			</el-row>
			<el-row class="footerhandler">
				<el-col :span="5" class="submitBtn_switch" style="text-align: right;color:transparent">1</el-col>
				<el-col :span="4" class="submitBtn"><div @click="savenotice">{{$lang.label.public.savebtn}}</div></el-col>
				<el-col :span="4" class="submitBtn_cancel"><div @click="reback">{{$lang.label.public.cancel}}</div></el-col>
			</el-row>
		</el-card>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	components: {
		
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data(){
		return {
			windowHeight: window.innerHeight - 120,
			type:'商城通知',
			divclass:'gonggao',
			gonggaolang:{},
			form:{
				msglist:[]
			},
			langlist:[]
		};
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/msg/gonggao.scss');
		this.GetLang();
		//this.GetNoticeMsg();
	},
	methods:{
		GetLang(){
			var that=this;
			this.$public.GetLanguageByMode('gonggao',this).then(res=>{
				//debugger
				if(res.state=='1'){
					that.gonggaolang=that.$lang.label.gonggao;
					that.GetLanglist();
				}
			});
		},
		addset(){
			this.form.msglist.push({notice:'',lang:''});
		},
		delset(index){
			this.form.msglist.splice(index,1);
		},
		GetLanglist(){
			//debugger
			var that = this;
			this.$apipost.get.dic({ type: '语言类型' }).then(res => {
				//debugger
				if (res.list != undefined) {
					that.langlist=res.list;
					if(that.form.msglist.length==0)
						this.form.msglist.push({
					notice:'',
					lang:that.langlist[0].value,
				});
					that.GetNoticeMsg();
				}
			});
		},
		GetNoticeMsg(){
			var that=this;
			var paraminfo={
				type:this.type
			}
			//debugger
			this.$apipost.get.GetNoticeMsg({paraminfo:paraminfo}).then(res => {
				if(res!=''){
					if(res.state=='1'){
						var list=[];
						res.list.forEach(e =>{
							list.push({notice:e.notice,lang:e.lang});
						});
						that.form.msglist=list;
					}
				}
			});
		},
		savenotice(){
			var that=this;
			var list=this.form.msglist.filter(function(e){
				return e.notice.trim()=='';
			});
			if(list.length>0){
				this.$tool.message(this.gonggaolang.noticeempty, 0);
				return false;
			}
			var paraminfo={
				type:this.type,
				msglist:this.form.msglist
			}
			//debugger
			this.$tool.loading(this.$lang.label.public.saving, this.divclass);
			this.$apipost.post.SaveNoticeMsg({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if(res!=''){
					if(res.state=='1'){
						this.$tool.message('保存成功', 1);
						setTimeout(function(){
							that.reback();
						},1000)
					}else{
						this.$tool.message('保存失败',0);
					}
				}
			});
		},
		reback(){
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		}
	}
}	
</script>

<style>
	
</style>